import React from 'react';
import ReactDOM from 'react-dom';

function convertToCSV(data) {
  const headers = [
    "Mile Start", "Mile End", "Pence per Mile", "Fixed Price in Pence", "Modified By", "Updated Time"
  ];

  const rows = data.flatMap(item => [
    [item.pricing_mile_start_1, item.pricing_mile_end_1, item.pricing_mile_pence_1, item.pricing_mile_fixed_price_in_pence_1, item.modified_by_user_name, item.created_at],
    [item.pricing_mile_start_2, item.pricing_mile_end_2, item.pricing_mile_pence_2, item.pricing_mile_fixed_price_in_pence_2, item.modified_by_user_name, item.created_at],
    [item.pricing_mile_start_3, item.pricing_mile_end_3, item.pricing_mile_pence_3, item.pricing_mile_fixed_price_in_pence_3, item.modified_by_user_name, item.created_at],
    [item.pricing_mile_start_4, item.pricing_mile_end_4, item.pricing_mile_pence_4, item.pricing_mile_fixed_price_in_pence_4, item.modified_by_user_name, item.created_at],
    ["", "", "", "", "", ""]
  ]);

  const csvContent = [
    headers.join(","), 
    ...rows.map(row => row.join(","))
  ].join("\n");

  return csvContent;
}

function downloadCSV(data) {
  if (data.length === 0) {
    alert('No data available to download');
    return;
  }

  const csvContent = convertToCSV(data);
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);
  link.setAttribute("href", url);
  link.setAttribute("download", `${data[0].customer_name} Pricing Data History.csv`);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

const CustomersTable = ({ data }) => {
  if (data.length === 0) {
    return <h1 class="mt-5 text-center">No data available</h1>;
  }

  return (
    <div className='mt-5'>
      <div className='row'>
        <div className="col-md-12 text-center">
          <h1>{data[0].customer_name} Pricing Data History</h1>
        </div>
      </div>
      <div className="text-right mb-3 mr-3 mb-3">
        <button 
          className="btn btn-primary mt-4 mr-4"
          onClick={() => downloadCSV(data)}
        >
          Download {data[0].customer_name} Pricing Data History Report
        </button>
      </div>
      <div className="ph-table-responsive">
        <table className="ph-table table-bordered">
          <thead>
            <tr>
              <th>Mile Start</th>
              <th>Mile End</th>
              <th>Pence per Mile</th>
              <th>Fixed Price in Pence</th>
              <th>Modified By</th>
              <th>Updated Time</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => (
              <React.Fragment key={index}>
                <tr>
                  <td>{item.pricing_mile_start_1}</td>
                  <td>{item.pricing_mile_end_1}</td>
                  <td>{item.pricing_mile_pence_1}</td>
                  <td>{item.pricing_mile_fixed_price_in_pence_1}</td>
                  <td>{item.modified_by_user_name}</td>
                  <td>{item.created_at}</td>
                </tr>
                <tr>
                  <td>{item.pricing_mile_start_2}</td>
                  <td>{item.pricing_mile_end_2}</td>
                  <td>{item.pricing_mile_pence_2}</td>
                  <td>{item.pricing_mile_fixed_price_in_pence_2}</td>
                  <td>{item.modified_by_user_name}</td>
                  <td>{item.created_at}</td>
                </tr>
                <tr>
                  <td>{item.pricing_mile_start_3}</td>
                  <td>{item.pricing_mile_end_3}</td>
                  <td>{item.pricing_mile_pence_3}</td>
                  <td>{item.pricing_mile_fixed_price_in_pence_3}</td>
                  <td>{item.modified_by_user_name}</td>
                  <td>{item.created_at}</td>
                </tr>
                <tr>
                  <td>{item.pricing_mile_start_4}</td>
                  <td>{item.pricing_mile_end_4}</td>
                  <td>{item.pricing_mile_pence_4}</td>
                  <td>{item.pricing_mile_fixed_price_in_pence_4}</td>
                  <td>{item.modified_by_user_name}</td>
                  <td>{item.created_at}</td>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                </tr>
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

if (document.getElementById('react-component-g4-logistics-portal-customer-pricing-history')) {
  const pricingData = JSON.parse(document.getElementById('react-component-g4-logistics-portal-customer-pricing-history').getAttribute('data-pricing-data'));
  ReactDOM.render(
    <CustomersTable data={pricingData} />,
    document.getElementById('react-component-g4-logistics-portal-customer-pricing-history')
  );
}
